import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { getScreenFromPathname, mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { SortOrder } from "@/types";

export const TableOrderByDropdown = <
  T extends { order: SortOrder; sort: string },
>({
  queryParams,
  setQueryParams,
  sortOptions,
}: {
  queryParams: T;
  setQueryParams: (queryParams: T) => void;
  sortOptions: { label: string; value: string }[];
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="h-8" variant="outlineSecondary">
          <ArrowUpDownIcon className="h-4 w-4" /> Order by
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="p-0">
        <DropdownMenuLabel>Ordering</DropdownMenuLabel>
        <DropdownMenuSeparator className="mb-0" />
        {sortOptions.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={(e) => {
              e.preventDefault();
              const newOrder =
                queryParams.order === SortOrder.Asc &&
                queryParams.sort === option.value
                  ? SortOrder.Desc
                  : SortOrder.Asc;

              setQueryParams({
                ...queryParams,
                order: newOrder,
                sort: option.value,
              });

              mixpanelUtils.trackFilterAndSortOptionSelected(
                getScreenFromPathname(location.pathname),
                "Sort/order by",
                option.value,
              );
            }}
            className="px-8"
          >
            <span className="absolute left-2">
              {queryParams.sort !== option.value ? null : queryParams.order ===
                SortOrder.Asc ? (
                <ArrowUpIcon className="h-4 w-4" />
              ) : (
                <ArrowDownIcon className="h-4 w-4" />
              )}
            </span>
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
